<template>
    <div class="row no-gutters">
        <div class="col-12">
            <div class="row no-gutters justify-content-space-evenly statistics-header">
                <div v-bind:class="{'tab-header-clicked': whosHotTabStates.hotJockey}" v-on:click="onWhosHotTabClicked('hotJockey')" class="col-5 col-md-2 text tab-header text-center"><span>HOT JOCKEY</span></div >
                <div v-bind:class="{'tab-header-clicked': whosHotTabStates.hotTrainer}" v-on:click="onWhosHotTabClicked('hotTrainer')" class="col-5 col-md-2 text tab-header text-center"><span>HOT TRAINER</span></div >
            </div>
            <div v-if="whosHotTabStates.hotJockey" class="col-12 p-0">
                <div class="row no-gutters">
                    <div style="position: relative;" class="col-12">
                        <div class="table-responsive">
                            <table class="table hot-jockey-table-border">
                                <thead class="thead-dark">
                                <tr class="table-subheader no-border-top">
                                    <th colspan="2"></th>
                                    <th colspan="6" class="text-center">LAST 30 RIDES</th>
                                    <th colspan="6" class="text-center">RIDES AT {{raceCourseAssets[selectedRaceCardSummary.raceCardSummary.raceTrackAssetId].raceCourseTitle.toUpperCase()}}</th>
                                    <th colspan="6" class="text-center">CURRENT SEASON</th>
                                    <th colspan="1">LOS</th>
                                </tr>
                                <tr class="no-border-top">
                                    <th scope="col">HOT</th>
                                    <th scope="col">JOCKEY</th>
                                    <th scope="col">RUNS</th>
                                    <th scope="col">1st</th>
                                    <th scope="col">2nd</th>
                                    <th scope="col">3rd</th>
                                    <th scope="col">W%</th>
                                    <th scope="col">P%</th>
                                    <th scope="col">RUNS</th>
                                    <th scope="col">1st</th>
                                    <th scope="col">2nd</th>
                                    <th scope="col">3rd</th>
                                    <th scope="col">W%</th>
                                    <th scope="col">P%</th>
                                    <th scope="col">RUNS</th>
                                    <th scope="col">1st</th>
                                    <th scope="col">2nd</th>
                                    <th scope="col">3rd</th>
                                    <th scope="col">W%</th>
                                    <th scope="col">P%</th>
                                    <th scope="col">SEQ</th>
                                </tr>
                                </thead>
                                <tbody v-if="(visibleHotJockeys.length > 0)">
                                <tr class="hot-jockey-table-row-border" v-for="(hotJockey, index) in visibleHotJockeys" :key="index">
                                    <td scope="row">{{hotJockey.hot}}</td>
                                    <td>{{hotJockey.jockeyTrainerName | hotjocktrain}}</td>
                                    <td class="highlighted-table-cell">{{hotJockey.lastRides}}</td>
                                    <td class="highlighted-table-cell">{{hotJockey.lastRidesFirst}}</td>
                                    <td class="highlighted-table-cell">{{hotJockey.lastRidesSecond}}</td>
                                    <td class="highlighted-table-cell">{{hotJockey.lastRidesThird}}</td>
                                    <td class="highlighted-table-cell">{{hotJockey.lastRidesWinPercentage}}</td>
                                    <td class="highlighted-table-cell">{{hotJockey.lastRidesPlacePercentage}}</td>
                                    <td>{{hotJockey.courseRides}}</td>
                                    <td>{{hotJockey.courseRidesFirst}}</td>
                                    <td>{{hotJockey.courseRidesSecond}}</td>
                                    <td>{{hotJockey.courseRidesThird}}</td>
                                    <td>{{hotJockey.courseRidesWinPercentage}}</td>
                                    <td>{{hotJockey.courseRidesPlacePercentage}}</td>
                                    <td class="highlighted-table-cell">{{hotJockey.seasonRides}}</td>
                                    <td class="highlighted-table-cell">{{hotJockey.seasonRidesFirst}}</td>
                                    <td class="highlighted-table-cell">{{hotJockey.seasonRidesSecond}}</td>
                                    <td class="highlighted-table-cell">{{hotJockey.seasonRidesThird}}</td>
                                    <td class="highlighted-table-cell">{{hotJockey.seasonRidesWinPercentage}}</td>
                                    <td class="highlighted-table-cell">{{hotJockey.seasonRidesPlacePercentage}}</td>
                                    <td>{{hotJockey.lossSequence}}</td>
                                </tr>
                                </tbody>
                                <tbody v-if="(visibleHotJockeys.length === 0)">
                                <tr>
                                    No Hot Jockeys
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="(visibleHotJockeys.length >= 8)" class="row no-gutters d-flex justify-content-center">
                            <div class="extra-rows-toggle-button col-12 btn text-center" v-on:click="toggleExtraJockeyResults('jockey')">
                                <img id="extra-rows-down-arrow-jockey" class="extra-rows-down-arrow" :src="getImage('fixtures-dropdown-icon')">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="whosHotTabStates.hotTrainer" class="col-12 p-0">
                <div class="row no-gutters">
                    <div style="position: relative;" class="col-12">
                        <div class="table-responsive">
                            <table class="table hot-jockey-table-border">
                                <thead class="thead-dark">
                                <tr class="table-subheader no-border-top">
                                    <th colspan="2"></th>
                                    <th colspan="6" class="text-center">LAST 30 RIDES</th>
                                    <th colspan="6" class="text-center">RIDES AT {{raceCourseAssets[selectedRaceCardSummary.raceCardSummary.raceTrackAssetId].raceCourseTitle.toUpperCase()}}</th>
                                    <th colspan="6" class="text-center">CURRENT SEASON</th>
                                    <th colspan="1">LOS</th>
                                </tr>
                                <tr class="no-border-top">
                                    <th scope="col">HOT</th>
                                    <th scope="col">TRAINER</th>
                                    <th scope="col">RUNS</th>
                                    <th scope="col">1st</th>
                                    <th scope="col">2nd</th>
                                    <th scope="col">3rd</th>
                                    <th scope="col">W%</th>
                                    <th scope="col">P%</th>
                                    <th scope="col">RUNS</th>
                                    <th scope="col">1st</th>
                                    <th scope="col">2nd</th>
                                    <th scope="col">3rd</th>
                                    <th scope="col">W%</th>
                                    <th scope="col">P%</th>
                                    <th scope="col">RUNS</th>
                                    <th scope="col">1st</th>
                                    <th scope="col">2nd</th>
                                    <th scope="col">3rd</th>
                                    <th scope="col">W%</th>
                                    <th scope="col">P%</th>
                                    <th scope="col">SEQ</th>
                                </tr>
                                </thead>
                                <tbody v-if="(visibleHotTrainers.length > 0)">
                                <tr class="hot-jockey-table-row-border" v-for="(hotTrainer, index) in visibleHotTrainers" :key="index">
                                    <td scope="row">{{hotTrainer.hot}}</td>
                                    <td>{{hotTrainer.jockeyTrainerName | hotjocktrain}}</td>
                                    <td class="highlighted-table-cell">{{hotTrainer.lastRides}}</td>
                                    <td class="highlighted-table-cell">{{hotTrainer.lastRidesFirst}}</td>
                                    <td class="highlighted-table-cell">{{hotTrainer.lastRidesSecond}}</td>
                                    <td class="highlighted-table-cell">{{hotTrainer.lastRidesThird}}</td>
                                    <td class="highlighted-table-cell">{{hotTrainer.lastRidesWinPercentage}}</td>
                                    <td class="highlighted-table-cell">{{hotTrainer.lastRidesPlacePercentage}}</td>
                                    <td>{{hotTrainer.courseRides}}</td>
                                    <td>{{hotTrainer.courseRidesFirst}}</td>
                                    <td>{{hotTrainer.courseRidesSecond}}</td>
                                    <td>{{hotTrainer.courseRidesThird}}</td>
                                    <td>{{hotTrainer.courseRidesWinPercentage}}</td>
                                    <td>{{hotTrainer.courseRidesPlacePercentage}}</td>
                                    <td class="highlighted-table-cell">{{hotTrainer.seasonRides}}</td>
                                    <td class="highlighted-table-cell">{{hotTrainer.seasonRidesFirst}}</td>
                                    <td class="highlighted-table-cell">{{hotTrainer.seasonRidesSecond}}</td>
                                    <td class="highlighted-table-cell">{{hotTrainer.seasonRidesThird}}</td>
                                    <td class="highlighted-table-cell">{{hotTrainer.seasonRidesWinPercentage}}</td>
                                    <td class="highlighted-table-cell">{{hotTrainer.seasonRidesPlacePercentage}}</td>
                                    <td>{{hotTrainer.lossSequence}}</td>
                                </tr>
                                </tbody>
                                <tbody v-if="(visibleHotTrainers.length === 0)">
                                <tr>
                                    No Hot Trainers
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="(visibleHotTrainers.length >= 8)" class="row no-gutters d-flex justify-content-center">
                            <div class="extra-rows-toggle-button col-12 btn text-center" v-on:click="toggleExtraTrainerResults('trainer')">
                                <img id="extra-rows-down-arrow-trainer" class="extra-rows-down-arrow" :src="getImage('fixtures-dropdown-icon')">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    import {HotJockeys} from '../assets/mockData/hotJockeys';
    import {RaceCourseAssets} from "./configuration/raceCourseAssetMapping.constant";
import jockeyTrainer from '../components/mixins/Jockey-TrainerName'

    export default {
        name: "WhosHot",
         mixins:[jockeyTrainer],
        data: function () {
            return {
                whosHotTabStates: {
                    hotJockey: true,
                    hotTrainer: false
                },
                visibleHotJockeys: [],
                visibleHotTrainers: [],
                hotJockeys: HotJockeys,
                hotTrainers: HotJockeys,
                areJockeyResultsExpanded: false,
                areTrainerResultsExpanded: false,
                raceCourseAssets: RaceCourseAssets
            };
        },
        computed: mapState(['selectedRaceStats', 'selectedRaceCardSummary']),
        methods: {
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            },
            onWhosHotTabClicked(tabName) {
                if (this.whosHotTabStates[tabName]) return;
                for(let tab in this.whosHotTabStates) {
                    if(this.whosHotTabStates[tab] && tabName === tab) {
                        this.whosHotTabStates[tab] = false;
                        return;
                    }
                    this.whosHotTabStates[tab] = tab === tabName;
                }
            },
            toggleExtraJockeyResults() {
                const rotationDeg = this.areJockeyResultsExpanded ? '0' : '180';
                document.querySelector(`#extra-rows-down-arrow-jockey`).style.transform = "rotate(" + rotationDeg + "deg)";
                this.areJockeyResultsExpanded = !this.areJockeyResultsExpanded;
                this.visibleHotJockeys = this.areJockeyResultsExpanded ? this.selectedRaceStats.hotJockeys : this.selectedRaceStats.hotJockeys.slice(0, 8);
            },
            toggleExtraTrainerResults() {
                const rotationDeg = this.areTrainerResultsExpanded ? '0' : '180';
                document.querySelector(`#extra-rows-down-arrow-trainer`).style.transform = "rotate(" + rotationDeg + "deg)";
                this.areTrainerResultsExpanded = !this.areTrainerResultsExpanded;
                this.visibleHotTrainers = this.areTrainerResultsExpanded ? this.selectedRaceStats.hotTrainers : this.selectedRaceStats.hotTrainers.slice(0, 8);
            }
        },
        mounted: function () {
            this.visibleHotJockeys = this.selectedRaceStats.hotJockeys.slice(0, 12);
            this.visibleHotTrainers = this.selectedRaceStats.hotTrainers.slice(0, 12);
        }
    }
</script>

<style scoped>
    .statistics-header {
        background-color: #000000;
    }

    .statistics-title-text {
        font-size: 1.8rem;
    }

    .tab-header {
        font-size: 0.8rem;
        padding: 0.5rem 0;
        font-weight: bold;
    }

    .tab-header:hover {
        cursor: pointer;
    }

    .tab-header-clicked {
        background-color: #FFFFFF;
        color: #000000;
    }

    th {
        font-size: 0.8rem;
        border: none;
        text-decoration: none;
    }

    tr {
        border: none;
        text-decoration: none;
    }

    .highlighted-table-cell {
        background-color: #f2f2f2;
    }

    .extra-rows-toggle-button {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 25px;
        background-color: #000000;
        padding: 0 !important;
        border: 1px solid #7c7c7c !important;
        margin-bottom: 0.5rem !important;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
    }

    .extra-rows-down-arrow {
        height: 35px;
        font-weight: bolder;
    }

    .hot-jockey-table-border {
        border: 1px solid #000000;
    }

    .hot-jockey-table-row-border {
        border-top: 1px solid #dee2e6;
    }

    .no-border-top {
        border-top-style: hidden;
    }

    th {
        font-size: 0.8rem;
        border: none;
        text-decoration: none;
    }

    @media (min-width: 1200px) {
        .tab-header {
            font-size: 1rem;
            padding: 0.5rem 0;
            font-weight: bold;
        }
    }

</style>